export default __webpack_public_path__ + "static/media/deepanshu.c1ad4626.jpg";